const locationToString = (location: Union.Location | null) => {
	const loc = location || ({} as Union.Location);
	return `${loc.city || ''}${loc.city && loc.stateCode ? ', ' : ''}${
		loc.stateCode || ''
	}`;
};

export default locationToString;
